module.exports = __webpack_public_path__ + "img/deposit-wallet.2014e8a6.svg";